import React, { Suspense, useCallback, useState } from "react";
import { AHSeparator, Box } from "arkh";
import { View } from "react-native";
import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";
import { KPIList } from "./KPIList";
import { KPISelector } from "./KPISelector";
import { KPIMainNavigationProps } from "./KPIMainNavigationProps";

export function KPIContent(
  props: {
    routineId: string;
    routineTitle: string;
    description?: string;
    sequenceNumber: number;
    teamId?: string;
    sectionIds?: string[];
  } & KPIMainNavigationProps
) {
  const [sequenceNumber, setSequenceNumber] = React.useState(
    props.sequenceNumber
  );

  const [lastFocusedSectionId, setLastFocusedSectionId] = useState<
    string | null
  >();
  const [hasMoved, setMoved] = useState(false);

  const render = useCallback(
    (fetchKey: string) => (
      <KPIList
        isActive={props.sequenceNumber === sequenceNumber}
        routineId={props.routineId}
        sequenceNumber={sequenceNumber}
        hasMoved={hasMoved}
        lastFocusedSectionId={lastFocusedSectionId ?? null}
        setLastFocusedSectionId={setLastFocusedSectionId}
        teamId={props.teamId}
        sectionIds={props.sectionIds}
        fetchKey={fetchKey}
        navigation={props.navigation}
        route={props.route}
      />
    ),
    [
      hasMoved,
      lastFocusedSectionId,
      props.navigation,
      props.route,
      props.routineId,
      props.sectionIds,
      props.sequenceNumber,
      props.teamId,
      sequenceNumber,
    ]
  );
  return (
    <View style={{ flex: 1 }}>
      <LazyQueryNetworkBoundrary>
        {(fetchKey) => (
          <Suspense fallback={<Box spaceBottom="small" />}>
            <KPISelector
              fetchKey={fetchKey}
              routineId={props.routineId}
              currentSequenceNumber={sequenceNumber}
              onSelectOccasion={(sequenceNumber) => {
                setMoved(true);
                setSequenceNumber(sequenceNumber);
              }}
            />
          </Suspense>
        )}
      </LazyQueryNetworkBoundrary>
      <AHSeparator />
      <LazyQueryNetworkBoundrary>{render}</LazyQueryNetworkBoundrary>
    </View>
  );
}
